import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';

const nf = (n) => (n == null ? '—' : Number(n).toLocaleString('it-IT'));
const card = { background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 14, padding: 18, flex: '1 1 320px' };
const h3 = { margin: '0 0 12px', fontSize: 14, fontWeight: 800, color: 'var(--text)' };
const row = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '6px 0', borderBottom: '1px solid var(--surface-2)', fontSize: 13 };

// Lucchetto: colore + significato commerciale
const LUC = {
  GRIGIO: { c: 'var(--faint)', l: 'Libera (aggredibile)' },
  VERDE: { c: 'var(--ok)', l: 'Cliente TIM' },
  NERO: { c: 'var(--text)', l: 'Presidiata' },
  VIOLA: { c: 'var(--info)', l: 'Presidio condizionato' },
  ROSSO: { c: 'var(--err)', l: 'Rosso' },
  GIALLO: { c: 'var(--warn)', l: 'Giallo' },
  ARANCIONE: { c: 'var(--warn)', l: 'Arancione' },
  'NON TROVATO': { c: 'var(--line)', l: 'Non trovata' },
};
const LUC_ORDER = ['GRIGIO', 'ROSSO', 'GIALLO', 'ARANCIONE', 'VERDE', 'VIOLA', 'NERO', 'NON TROVATO'];

function Stat({ label, value, color, sub }) {
  return (
    <div style={{ flex: '1 1 120px', textAlign: 'center', padding: '6px 4px' }}>
      <div style={{ fontSize: 24, fontWeight: 800, color: color || 'var(--text)' }}>{nf(value)}</div>
      <div style={{ fontSize: 12, color: 'var(--muted)' }}>{label}</div>
      {sub != null && <div style={{ fontSize: 11, color: 'var(--faint)' }}>{sub}</div>}
    </div>
  );
}

export default function SsmateDashboardPage() {
  const [d, setD] = useState(null);

  const load = useCallback(() => {
    axios.get(`${API}/ssmate/dashboard`).then((r) => setD(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [load]);

  if (!d) return <div style={{ padding: 24, color: 'var(--muted)' }}>Caricamento…</div>;

  const v = d.verifiche || {};
  const pctVerif = v.con_cf ? Math.round((100 * v.verificati) / v.con_cf) : 0;
  const luc = d.lucchetti || {};
  const totLuc = Object.values(luc).reduce((a, b) => a + b, 0);
  const job = d.agente?.job;

  return (
    <div style={{ padding: 20, maxWidth: 1050, margin: '0 auto' }}>
      <h1 style={{ fontSize: 20, margin: '0 0 4px' }}>Dashboard SSMATE</h1>
      <p style={{ margin: '0 0 18px', color: 'var(--muted)', fontSize: 13 }}>
        Presidio commerciale TIM (Digital Sales Mate){d.timing?.abilitato ? ` · timing ${d.timing.giorni} giorni` : ''}
      </p>

      {/* Verifiche + Agente */}
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
        <div style={card}>
          <h3 style={h3}>Verifiche</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Stat label="Aziende con CF" value={v.con_cf} />
            <Stat label="Verificate" value={v.verificati} color="#2563eb" sub={`${pctVerif}%`} />
            <Stat label="Da verificare" value={v.verificabili} color="#b45309" />
            <Stat label="Lavorabili" value={v.lavorabili} color="#16a34a" />
          </div>
          <div style={{ height: 8, background: 'var(--surface-2)', borderRadius: 5, overflow: 'hidden', marginTop: 6 }}>
            <div style={{ width: `${pctVerif}%`, height: '100%', background: 'var(--info)' }} />
          </div>
        </div>

        <div style={card}>
          <h3 style={h3}>AI SSMATE</h3>
          <div style={row}>
            <span>Stato</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontWeight: 700 }}>
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: d.agente?.attivo ? 'var(--ok)' : 'var(--line)', display: 'inline-block' }} />
              {d.agente?.attivo ? 'Attivo' : 'Spento'}
            </span>
          </div>
          {job ? (
            <>
              <div style={row}><span>In corso</span><b>{job.current || '—'}</b></div>
              <div style={row}><span>Avanzamento</span><b>{nf(job.completed)}/{nf(job.total)}</b></div>
              <div style={{ ...row, borderBottom: 'none' }}><span>Utente</span><b>{job.current_user || '—'}</b></div>
            </>
          ) : (
            <div style={{ ...row, borderBottom: 'none', color: 'var(--faint)' }}>
              <span>{d.agente?.attivo ? 'In attesa (nessun batch in corso)' : 'Nessuna verifica in corso'}</span>
            </div>
          )}
        </div>
      </div>

      {/* Esiti lucchetti */}
      <div style={{ ...card, marginBottom: 16 }}>
        <h3 style={h3}>Esiti — lucchetti ({nf(totLuc)} verificate)</h3>
        {totLuc === 0 ? (
          <div style={{ fontSize: 13, color: 'var(--faint)' }}>Nessuna verifica ancora.</div>
        ) : (
          LUC_ORDER.filter((k) => luc[k]).map((k) => {
            const meta = LUC[k] || { c: 'var(--faint)', l: k };
            const pct = Math.round((100 * luc[k]) / totLuc);
            return (
              <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '5px 0' }}>
                <span style={{ width: 11, height: 11, borderRadius: '50%', background: meta.c, border: k === 'NON TROVATO' ? '1px solid var(--faint)' : 'none', flex: '0 0 auto' }} />
                <span style={{ flex: '0 0 180px', fontSize: 13 }}>{meta.l}</span>
                <div style={{ flex: 1, height: 8, background: 'var(--surface-2)', borderRadius: 5, overflow: 'hidden' }}>
                  <div style={{ width: `${pct}%`, height: '100%', background: meta.c }} />
                </div>
                <span style={{ flex: '0 0 90px', textAlign: 'right', fontSize: 13 }}><b>{nf(luc[k])}</b> <span style={{ color: 'var(--faint)' }}>({pct}%)</span></span>
              </div>
            );
          })
        )}
        <div style={{ marginTop: 10, fontSize: 13, color: 'var(--muted)' }}>
          Lavorabili: <b style={{ color: 'var(--ok)' }}>{nf(v.lavorabili)}</b> ·
          Non lavorabili: <b style={{ color: 'var(--err)' }}>{nf(Math.max(0, (v.verificati || 0) - (v.lavorabili || 0)))}</b>
        </div>
      </div>

      {/* Utenti & Attività */}
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
        <div style={card}>
          <h3 style={h3}>Utenti & crediti</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Stat label="Configurati" value={d.utenti?.totali} />
            <Stat label="Abilitati" value={d.utenti?.abilitati} />
            <Stat label="Disponibili oggi" value={d.utenti?.disponibili} color="#16a34a" />
          </div>
          {d.utenti?.esauriti?.length > 0 && (
            <div style={{ fontSize: 12, color: 'var(--warn)', marginTop: 8 }}>
              Esauriti oggi: {d.utenti.esauriti.join(', ')}
            </div>
          )}
        </div>

        <div style={card}>
          <h3 style={h3}>Attività verifiche</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Stat label="Oggi" value={d.uso?.oggi} color="#2563eb" />
            <Stat label="7 giorni" value={d.uso?.settimana} />
            <Stat label="30 giorni" value={d.uso?.mese} />
            <Stat label="Totale" value={d.uso?.totale} />
          </div>
          {Object.keys(d.uso?.per_utente_oggi || {}).length > 0 && (
            <div style={{ marginTop: 8 }}>
              <div style={{ fontSize: 11, color: 'var(--faint)', marginBottom: 4 }}>Oggi per utente:</div>
              {Object.entries(d.uso.per_utente_oggi).map(([u, n]) => (
                <div key={u} style={{ ...row, padding: '3px 0' }}><span>{u}</span><b>{nf(n)}</b></div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
